import { cloneDeep } from '@apollo/client/utilities';
import { PdfComponent, PdfTemplateDocumentProperties } from '../../ui/pages/PdfTemplateEditor/PdfComponent';
import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { PdfTemplate, PdfTemplateEntitySubtype, PdfTemplateEntityType } from './pdfTemplate';

export class PdfTemplateInput extends PdfTemplate implements EntityInput<PdfTemplate> {
  withEntityType(entityType: PdfTemplateEntityType) {
    this.entityType = entityType;
    return cloneDeep(this);
  }

  withEntitySubtype(entitySubtype: PdfTemplateEntitySubtype) {
    this.entitySubtype = entitySubtype;
    return cloneDeep(this);
  }

  withDocumentProperties(documentProperties: PdfTemplateDocumentProperties) {
    this.properties.document = documentProperties;
    return cloneDeep(this);
  }

  withComponents(components: PdfComponent[]) {
    this.properties.components = components;
    return cloneDeep(this);
  }

  forCreate() {
    return CreatePdfTemplateInput.from(this, CreatePdfTemplateInput);
  }

  forUpdate() {
    return UpdatePdfTemplateInput.from(this, UpdatePdfTemplateInput);
  }

  forDelete() {
    return DeletePdfTemplateInput.from(this, DeletePdfTemplateInput);
  }
}

export class CreatePdfTemplateInput extends forCreate(PdfTemplate) {}

export class UpdatePdfTemplateInput extends forUpdate(PdfTemplate) {}

export class DeletePdfTemplateInput extends forDelete(PdfTemplate) {}
